import React from "react";
import {withStyles} from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

const Switcher = withStyles(theme => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: "flex",
    },
    switchBase: {
        padding: 2,
        color: "gray",
        "&$checked": {
            transform: "translateX(12px)",
            color: "white",
            "& + $track": {
                opacity: 1,
                backgroundColor: "#3783e7 !important",
                borderColor: "#3783e7 !important",
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: "none",
    },
    track: {
        border: `1px solid gray`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: "white",
    },
    checked: {},
}))(Switch);

export const CustomSwitch = ({disabled, checked, onChange}) => {
    return (
        <Switcher
            disabled={disabled || false}
            checked={!!checked}
            onChange={onChange}
            color="primary"
            //   size={size}
        />
    );
};
